import type membersEn from "./members.en";

const membersFr: Record<keyof typeof membersEn, string> = {
  "admin.members.text0": "Synchronisé",
  "admin.members.text1": "Exporté",
  "admin.members.text2": "Nouveau",
  "admin.members.text3": "Jamais exporté vers Proton",
  "admin.members.text4": "Présent dans Proton",
  "admin.members.text5": "dans Proton",
  "admin.members.text6": "Historique Proton",
  "admin.members.text7": "Réinitialiser le suivi Proton",
  "admin.members.text8": "Erreur lors du chargement des membres",
  "admin.members.text9": "Erreur lors du chargement des inscriptions",
  "admin.members.text10": "Accès accordé",
  "admin.members.text11": "Accès révoqué",
  "admin.members.text12": "Erreur lors de la mise à jour",
  "admin.members.text13": "Statut mis à jour",
  "admin.members.text14": "Invitation WhatsApp envoyée avec succès",
  "admin.members.text15": "Erreur lors de l'envoi de l'invitation",
  "admin.members.text16": "Lien magique envoyé avec succès",
  "admin.members.text17": "Erreur lors de l'envoi du lien magique",
  "admin.members.text18": "Accès accordé avec succès. 2 emails envoyés.",
  "admin.members.text19": "Erreur lors de l'octroi de l'accès",
  "admin.members.text20": "Lien magique renvoyé avec succès",
  "admin.members.text21": "Membre supprimé avec succès",
  "admin.members.text22": "Erreur lors de la suppression du membre",
  "admin.members.text23": "Erreur lors du chargement de l'historique",
  "admin.members.text24": "Erreur lors du chargement de la preuve d'acceptation",
  "admin.members.text25": "Erreur lors du chargement des notes",
  "admin.members.text26": "Note ajoutée",
  "admin.members.text27": "Erreur lors de l'ajout de la note",
  "admin.members.text28": "Note supprimée",
  "admin.members.text29": "Erreur lors de la suppression de la note",
  "admin.members.text30": "Contacté",
  "admin.members.text31": "Ajouté au groupe",
  "admin.members.text32": "Retiré du groupe",
  "admin.members.text33": "Bouche à oreille",
  "admin.members.text34": "Presse / Médias",
  "admin.members.text35": "Réseaux sociaux",
  "admin.members.text36": "Prénom",
  "admin.members.text37": "Téléphone",
  "admin.members.text38": "Oui",
  "admin.members.text39": "Non",
  "admin.members.text40": "Export CSV réussi",
  "admin.members.text41": "Aucun nouveau membre à exporter (tous les filtrés ont déjà été exportés).",
  "admin.members.text42": "Aucun membre exportable (les inscriptions retirées sont exclues).",
  "admin.members.text43": "Synchronisation Proton retirée",
  "admin.members.text44": "Marqué comme synchronisé",
  "admin.members.text45": "Aucune sélection à marquer (déjà synchronisés ou vides).",
  "admin.members.text46": "Erreur lors du marquage",
  "admin.members.text47": "Erreur lors de la réinitialisation",
  "admin.members.text48": "Suivi Proton réinitialisé",
  "admin.members.text49": "Erreur de chargement de l'historique",
  "admin.members.text50": "Aucune inscription éligible",
  "admin.members.text51": "Gestion des membres",
  "admin.members.text52": "Inscriptions (",
  "admin.members.text53": ")",
  "admin.members.text54": "Gérez les inscriptions et les accès membres",
  "admin.members.text55": "Exporter vCard",
  "admin.members.text56": "Export vCard pour Proton",
  "admin.members.text57": "Les inscriptions retirées sont toujours exclues.",
  "admin.members.text58": "Que veux-tu exporter ?",
  "admin.members.text59": "Tous les filtrés",
  "admin.members.text60": "Ma sélection (",
  "admin.members.text61": "Exclure les déjà exportés",
  "admin.members.text62": "Export incrémental : ignore les membres déjà exportés vers Proton.",
  "admin.members.text63": "contact",
  "admin.members.text64": "dans l'export",
  "admin.members.text65": "Télécharger (",
  "admin.members.text66": "Exporter CSV",
  "admin.members.text67": "Rechercher (nom, email, téléphone)...",
  "admin.members.text68": "WhatsApp : tous",
  "admin.members.text69": "WhatsApp accepté",
  "admin.members.text70": "WhatsApp refusé",
  "admin.members.text71": "Tous",
  "admin.members.text72": "En attente",
  "admin.members.text73": "Ajouté",
  "admin.members.text74": "Retiré",
  "admin.members.text75": "Date : plus récent",
  "admin.members.text76": "Date : plus ancien",
  "admin.members.text77": "Nom : A → Z",
  "admin.members.text78": "Nom : Z → A",
  "admin.members.text79": "Statut : A → Z",
  "admin.members.text80": "Statut : Z → A",
  "admin.members.text81": "Dernière connexion (récente)",
  "admin.members.text82": "Dernière connexion (ancienne)",
  "admin.members.text83": "Proton : tous",
  "admin.members.text84": "Jamais exportés",
  "admin.members.text85": "Exportés non sync.",
  "admin.members.text86": "Synchronisés",
  "admin.members.text87": "Chargement...",
  "admin.members.text88": "Aucune inscription",
  "admin.members.text89": "Tout sélectionner",
  "admin.members.text90": "Nom & Prénom",
  "admin.members.text91": "Email",
  "admin.members.text92": "Dernière connexion",
  "admin.members.text93": "WhatsApp",
  "admin.members.text94": "Source",
  "admin.members.text95": "Statut",
  "admin.members.text96": "Consentements",
  "admin.members.text97": "Date",
  "admin.members.text98": "Accès membre",
  "admin.members.text99": "Proton",
  "admin.members.text100": "Actions",
  "admin.members.text101": "Jamais connecté — cliquer pour voir l'historique",
  "admin.members.text102": "—",
  "admin.members.text103": "CG",
  "admin.members.text104": "Charte",
  "admin.members.text105": "RGPD",
  "admin.members.text106": "Validé",
  "admin.members.text107": "Révoquer",
  "admin.members.text108": "Accorder",
  "admin.members.text109": "L'accès membre doit être validé d'abord",
  "admin.members.text110": "Historique des liens magiques",
  "admin.members.text111": "Le membre n'a pas demandé à rejoindre le groupe",
  "admin.members.text112": "Le membre a déjà été ajouté au groupe",
  "admin.members.text113": "Voir l'historique des statuts",
  "admin.members.text114": "Supprimer le membre",
  "admin.members.text115": "Date d'inscription",
  "admin.members.text116": "Accès validé",
  "admin.members.text117": "En attente de validation",
  "admin.members.text118": "Accorder l'accès membre",
  "admin.members.text119": "Renvoyer le lien magique",
  "admin.members.text120": "Inviter",
  "admin.members.text121": "sélectionné",
  "admin.members.text122": "Exporter",
  "admin.members.text123": "Marquer synchronisés",
  "admin.members.text124": "Désélectionner",
  "admin.members.text125": "(",
  "admin.members.text126": "Aucun événement Proton pour ce membre.",
  "admin.members.text127": "Exporté (.vcf)",
  "admin.members.text128": "Marqué synchronisé",
  "admin.members.text129": "Synchronisation retirée",
  "admin.members.text130": "Suivi réinitialisé",
  "admin.members.text131": "Action groupée",
  "admin.members.text132": "Premier export",
  "admin.members.text133": "Format :",
  "admin.members.text134": "Notes internes",
  "admin.members.text135": "Ajouter une note",
  "admin.members.text136": "Entrez votre note ici...",
  "admin.members.text137": "Ajouter la note",
  "admin.members.text138": "Notes existantes (",
  "admin.members.text139": "Aucune note pour le moment",
  "admin.members.text140": "Supprimer la note",
  "admin.members.text141": "Historique des statuts",
  "admin.members.text142": "Aucun historique disponible",
  "admin.members.text143": "→",
  "admin.members.text144": "Acceptation de la charte du Collectif",
  "admin.members.text145": "Chargement…",
  "admin.members.text146": "Aucune preuve enregistrée — inscription antérieure au système de journalisation.",
  "admin.members.text147": "Version de la charte",
  "admin.members.text148": "Date et heure",
  "admin.members.text149": "Adresse IP",
  "admin.members.text150": "Consentement",
  "admin.members.text151": "User-agent",
  "admin.members.text152": "Texte exact de la déclaration",
  "admin.members.text153": "Enregistrement immuable conservé à titre de preuve légale.",
  "admin.members.text154": "Acceptation de la politique de confidentialité",
  "admin.members.text155": "Version de la politique",
  "admin.members.text156": "Confirmer l'envoi",
  "admin.members.text157": "Êtes-vous sûr de vouloir envoyer l'invitation WhatsApp à",
  "admin.members.text158": ") ?",
  "admin.members.text159": "Annuler",
  "admin.members.text160": "Confirmer",
  "admin.members.text161": "Confirmer l'envoi du lien magique",
  "admin.members.text162": "Êtes-vous sûr de vouloir envoyer le lien magique à",
  "admin.members.text163": "Aucun envoi de lien magique pour le moment",
  "admin.members.text164": "Envoyé avec succès",
  "admin.members.text165": "Échec",
  "admin.members.text166": "Email :",
  "admin.members.text167": "Confirmer l'activation de l'espace membre",
  "admin.members.text168": "Deux emails seront envoyés à",
  "admin.members.text169": ") :",
  "admin.members.text170": "1.",
  "admin.members.text171": "Email de confirmation d'activation",
  "admin.members.text172": "2.",
  "admin.members.text173": "Email avec le lien de connexion (pensez à vérifier les spams)",
  "admin.members.text174": "Confirmer l'activation",
  "admin.members.text175": "Confirmer la suppression",
  "admin.members.text176": "⚠️ Cette action est irréversible !",
  "admin.members.text177": "Vous êtes sur le point de supprimer définitivement",
  "admin.members.text178": ").",
  "admin.members.text179": "Cette action va supprimer :",
  "admin.members.text180": "L'inscription",
  "admin.members.text181": "Le profil membre",
  "admin.members.text182": "Le compte utilisateur",
  "admin.members.text183": "Toutes les données associées (notes, historique, etc.)",
  "admin.members.text184": "Supprimer définitivement",
  "admin.members.text185": "Error",
  "admin.members.text186": "You must be logged in to setup 2FA",
  "admin.members.text187": "2FA Setup Started",
  "admin.members.text188": "Scan the QR code with your authenticator app",
  "admin.members.text189": "Failed to setup 2FA. Please try again.",
  "admin.members.text190": "Invalid Code",
  "admin.members.text191": "Please enter a 6-digit code",
  "admin.members.text192": "The verification code is incorrect",
  "admin.members.text193": "2FA Enabled",
  "admin.members.text194": "Two-factor authentication has been successfully enabled",
  "admin.members.text195": "Failed to enable 2FA. Please try again.",
  "admin.members.text196": "Are you sure you want to disable 2FA? This will make your account less secure.",
  "admin.members.text197": "2FA Disabled",
  "admin.members.text198": "Two-factor authentication has been disabled",
  "admin.members.text199": "Failed to disable 2FA. Please try again.",
  "admin.members.text200": "Copied",
  "admin.members.text201": "Copied to clipboard",
  "admin.members.text202": "Sécurité — 2FA",
  "admin.members.text203": "Two-Factor Authentication (2FA)",
  "admin.members.text204": "Add an extra layer of security to your admin account",
  "admin.members.text205": "Two-factor authentication is currently",
  "admin.members.text206": "enabled",
  "admin.members.text207": "for your account. You'll be prompted for a code when logging in.",
  "admin.members.text208": "Disable 2FA",
  "admin.members.text209": "Save your backup codes!",
  "admin.members.text210": "They can be used to access your account if you lose your authenticator device.",
  "admin.members.text211": "Step 1: Scan QR Code",
  "admin.members.text212": "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)",
  "admin.members.text213": "2FA QR Code",
  "admin.members.text214": "Or enter this code manually:",
  "admin.members.text215": "Step 2: Save Backup Codes",
  "admin.members.text216": "Store these codes in a safe place. Each code can only be used once.",
  "admin.members.text217": "Copy All Backup Codes",
  "admin.members.text218": "Step 3: Verify",
  "admin.members.text219": "Enter the 6-digit code from your authenticator app to complete setup",
  "admin.members.text220": "000000",
  "admin.members.text221": "Verify & Enable",
  "admin.members.text222": "disabled",
  "admin.members.text223": ". Enable it to add an extra layer of security to your admin account.",
  "admin.members.text224": "What you'll need:",
  "admin.members.text225": "An authenticator app (Google Authenticator, Authy, Microsoft Authenticator, etc.)",
  "admin.members.text226": "A safe place to store backup codes",
  "admin.members.text227": "Enable 2FA",
  "admin.members.text228": "Erreur de chargement",
  "admin.members.text229": "Impossible de récupérer les logs",
  "admin.members.text230": "Export CSV généré",
  "admin.members.text231": "Accès refusé",
  "admin.members.text232": "Cette page est réservée aux administrateurs.",
  "admin.members.text233": "Vérification des permissions…",
  "admin.members.text234": "Tentatives de connexion",
  "admin.members.text235": "Journal des connexions à l'espace membre et à l'admin (mot de passe, 2FA, lien magique). Les emails sont conservés",
  "admin.members.text236": "en clair",
  "admin.members.text237": ", l'accès est",
  "admin.members.text238": "réservé aux administrateurs",
  "admin.members.text239": "(RLS) et la rétention est de",
  "admin.members.text240": "90 jours",
  "admin.members.text241": ". Aucun mot de passe ni code 2FA n'est stocké.",
  "admin.members.text242": "Exporter CSV (",
  "admin.members.text243": "Filtres",
  "admin.members.text244": "Affinez par période, résultat, espace ou méthode.",
  "admin.members.text245": "Email, IP, raison…",
  "admin.members.text246": "Résultat",
  "admin.members.text247": "Tous les résultats",
  "admin.members.text248": "Succès",
  "admin.members.text249": "Espace",
  "admin.members.text250": "Tous les espaces",
  "admin.members.text251": "Admin",
  "admin.members.text252": "Membre",
  "admin.members.text253": "Méthode",
  "admin.members.text254": "Toutes les méthodes",
  "admin.members.text255": "Mot de passe",
  "admin.members.text256": "2FA",
  "admin.members.text257": "Lien magique",
  "admin.members.text258": "Date début",
  "admin.members.text259": "Actualiser",
  "admin.members.text260": "Effacer les filtres",
  "admin.members.text261": "entrée",
  "admin.members.text262": "Tentatives",
  "admin.members.text263": "Limité aux 1000 dernières entrées.",
  "admin.members.text264": "Aucune tentative pour ces critères.",
  "admin.members.text265": "Raison :",
  "admin.members.text266": "ip:",
  "admin.members.text267": "ua:",
  "admin.members.text268": "Adresse IP invalide",
  "admin.members.text269": "Cette IP est déjà dans la liste",
  "admin.members.text270": "Erreur lors de l'ajout",
  "admin.members.text271": "IP ajoutée",
  "admin.members.text272": "Erreur de mise à jour",
  "admin.members.text273": "Erreur de suppression",
  "admin.members.text274": "IP supprimée",
  "admin.members.text275": "Défi Cloudflare forcé par IP",
  "admin.members.text276": "Les adresses IP listées ci-dessous reçoivent automatiquement le défi Cloudflare (Turnstile) à chaque nouvelle session, sans dépendre de l'analyse comportementale. Désactivez une entrée pour la suspendre temporairement, ou supprimez-la pour retirer définitivement la règle.",
  "admin.members.text277": "Ajouter une IP",
  "admin.members.text278": "ex. 193.39.2.173",
  "admin.members.text279": "Motif (optionnel)",
  "admin.members.text280": "ex. Bot de monitoring iAdvize",
  "admin.members.text281": "Ajouter",
  "admin.members.text282": "IP configurées (",
  "admin.members.text283": "Aucune IP forcée pour le moment.",
  "admin.members.text284": "IP",
  "admin.members.text285": "Motif",
  "admin.members.text286": "Ajoutée le",
  "admin.members.text287": "Actif",
  "admin.members.text288": "Supprimer cette IP ?",
  "admin.members.text289": "L'IP",
  "admin.members.text290": "ne recevra plus automatiquement le défi Cloudflare.",
  "admin.members.text291": "Supprimer",
  "admin.members.text292": "Erreur",
  "admin.members.text293": "Libellé requis",
  "admin.members.text294": "Canari créé",
  "admin.members.text295": "Token copié",
  "admin.members.text296": "Accès refusé.",
  "admin.members.text297": "Canaris de contenu",
  "admin.members.text298": "Nouveau canari",
  "admin.members.text299": "À quoi servent les canaris ?",
  "admin.members.text300": "Chaque canari est un jeton unique injecté de façon invisible dans le HTML prérendu du site public (commentaire + span",
  "admin.members.text301": "font-size:0",
  "admin.members.text302": "). S'il réapparaît ailleurs (article concurrent, base de données revendue, copie cache), c'est la preuve d'une exfiltration. Recherchez-le périodiquement.",
  "admin.members.text303": "Canaris",
  "admin.members.text304": "Le premier canari actif est injecté à chaque build. Créez-en un nouveau périodiquement pour dater une éventuelle fuite.",
  "admin.members.text305": "Aucun canari.",
  "admin.members.text306": "Token",
  "admin.members.text307": "Libellé",
  "admin.members.text308": "Créé",
  "admin.members.text309": "Désactivé",
  "admin.members.text310": "Inactif",
  "admin.members.text311": "Copier le token",
  "admin.members.text312": "Rechercher sur le web",
  "admin.members.text313": "Désactiver",
  "admin.members.text314": "Réactiver",
  "admin.members.text315": "Génère un jeton unique. Sera injecté dans le HTML lors du prochain build.",
  "admin.members.text316": "Libellé (ex: Juillet 2026)",
  "admin.members.text317": "Désactiver les canaris précédents",
  "admin.members.text318": "Création…",
  "admin.members.text319": "Créer",
  "admin.members.text320": "Rechercher la fuite",
  "admin.members.text321": "Whitelistée",
  "admin.members.text322": "Bloquée",
  "admin.members.text323": "Auto-bloquée",
  "admin.members.text324": "Réseau",
  "admin.members.text325": "CF actif",
  "admin.members.text326": "CF non appliqué",
  "admin.members.text327": "Règle réseau Cloudflare appliquée",
  "admin.members.text328": "Blocage réseau impossible",
  "admin.members.text329": "Cloudflare non configuré ou refus API. La règle locale (Actions) a été appliquée.",
  "admin.members.text330": "Règle enregistrée",
  "admin.members.text331": "Règle supprimée",
  "admin.members.text332": "IP whitelistée",
  "admin.members.text333": "Accès & blocages",
  "admin.members.text334": "Blocage manuel d'adresses IP et de réseaux (ASN). Les crawlers vérifiés (Googlebot, Bingbot, …) ne sont jamais bloqués.",
  "admin.members.text335": "ASN",
  "admin.members.text336": "Bloquer",
  "admin.members.text337": "Whitelister",
  "admin.members.text338": "Niveau",
  "admin.members.text339": "Actions (app)",
  "admin.members.text340": "Réseau – Cloudflare",
  "admin.members.text341": "Raison (optionnel)",
  "admin.members.text342": "ℹ️",
  "admin.members.text343": ": bloque inscription, contact et connexion mais conserve les analytics.",
  "admin.members.text344": "Réseau (Cloudflare)",
  "admin.members.text345": ": blocage total du site via une règle Cloudflare.",
  "admin.members.text346": "Le niveau",
  "admin.members.text347": "nécessite que les secrets Cloudflare (CLOUDFLARE_API_TOKEN, CLOUDFLARE_ZONE_ID) soient configurés ; sinon le blocage retombe en niveau",
  "admin.members.text348": ".",
  "admin.members.text349": "Bloquer un ASN bloque immédiatement les IP de ce réseau",
  "admin.members.text350": "déjà observées",
  "admin.members.text351": "sur le site. Les nouvelles IP du même ASN seront refusées au moment où elles tenteront d'accéder.",
  "admin.members.text352": "Type",
  "admin.members.text353": "Cible",
  "admin.members.text354": "Raison",
  "admin.members.text355": "IP impactées",
  "admin.members.text356": "Mise à jour",
  "admin.members.text357": "Aucune règle d'accès.",
  "admin.members.text358": "Débloquer",
  "admin.members.text359": "Membre supprimé",
  "admin.members.text360": "Statut modifié",
  "admin.members.text361": "Nettoyage tokens",
  "admin.members.text362": "Export Proton (.vcf)",
  "admin.members.text363": "Proton synchronisé",
  "admin.members.text364": "Sync Proton retirée",
  "admin.members.text365": "Suivi Proton réinit.",
  "admin.members.text366": "Tokens de vérification",
  "admin.members.text367": "Impossible de charger les logs d'audit",
  "admin.members.text368": "Système",
  "admin.members.text369": "Logs d'audit",
  "admin.members.text370": "Rechercher...",
  "admin.members.text371": "Type d'action",
  "admin.members.text372": "Toutes les actions",
  "admin.members.text373": "Administrateur",
  "admin.members.text374": "Tous les admins",
  "admin.members.text375": "résultat",
  "admin.members.text376": "Historique des actions",
  "admin.members.text377": "Toutes les actions administratives sensibles sont enregistrées ici",
  "admin.members.text378": "Aucun log d'audit trouvé",
  "admin.members.text379": "Turnstile non configuré",
  "admin.members.text380": "Turnstile non coché",
  "admin.members.text381": "Turnstile expiré",
  "admin.members.text382": "Précision « autre » manquante",
  "admin.members.text383": "Téléphone manquant",
  "admin.members.text384": "Téléphone invalide",
  "admin.members.text385": "Erreur DB (vérif email)",
  "admin.members.text386": "Email déjà inscrit",
  "admin.members.text387": "Erreur DB (insertion)",
  "admin.members.text388": "Envoi email Resend échoué",
  "admin.members.text389": "Exception non gérée",
  "admin.members.text390": "Logs inscriptions",
  "admin.members.text391": "Échecs renvoyés par la fonction d'inscription (Turnstile, doublons, Resend, erreurs serveur…). Les emails sont stockés sous forme de hash SHA-256 pour préserver la vie privée.",
  "admin.members.text392": "Rechercher (code, IP, requestId…)",
  "admin.members.text393": "Code d'erreur",
  "admin.members.text394": "Tous les codes",
  "admin.members.text395": "échec",
  "admin.members.text396": "Incidents",
  "admin.members.text397": "Limité aux 1000 dernières entrées. Affinez avec les filtres pour cibler une période ou un code d'erreur précis.",
  "admin.members.text398": "Aucun échec d'inscription pour ces critères.",
  "admin.members.text399": "HTTP",
  "admin.members.text400": "requestId:",
  "admin.members.text401": "email#:",
  "admin.members.text402": "…",
  "admin.members.text403": "Détails techniques",
  "admin.members.text404": "Historique de connexion",
  "admin.members.text405": "50 dernières connexions enregistrées.",
  "admin.members.text406": "Aucune connexion enregistrée.",
  "admin.members.text407": "IP :",
  "admin.members.text408": "Moteur de recherche",
  "admin.members.text409": "Autre",
  "admin.members.text410": "Profil membre",
  "admin.members.text411": "Inscription",
  "admin.members.text412": "Nom",
  "admin.members.text413": "Date fin",
  "admin.members.text414": "Non connecté",
  "admin.members.text415": "Synchronisé le {v0}",
  "admin.members.text416": "Exporté le {v0}",
  "admin.members.text417": "Export vCard réussi ({v0} contacts)",
  "admin.members.text418": "{v0} membre(s) marqué(s) comme synchronisé(s)",
  "admin.members.text419": "Traitement de {v0} inscription(s)...",
  "admin.members.text420": "{v0} action(s) réussie(s)",
  "admin.members.text421": "{v0} réussie(s), {v1} en erreur",
  "admin.members.text422": "Sélectionner {v0} {v1}",
  "admin.members.text423": "{v0} — cliquer pour voir l'historique",
  "admin.members.text424": "Notes internes ({v0})",
  "admin.members.text425": "Charte du {v0} acceptée",
  "admin.members.text426": "Charte du {v0} non acceptée",
  "admin.members.text427": "Politique de confidentialité du {v0} acceptée",
  "admin.members.text428": "Politique de confidentialité du {v0} non acceptée",
  "admin.members.text429": "Jamais",
  "admin.members.text430": "Date invalide",
  "admin.members.text431": "{date} à {time}",
  "admin.members.text432": "{v0} ligne(s) exportée(s).",
  "admin.members.text433": "50 dernières connexions de {v0}.",
  "admin.members.unknownAdmin": "Admin inconnu"
};

export default membersFr;
